import { RequestData } from '@ant-design/pro-components';

import { request } from '@umijs/max';

import {
  AddLabelRequest,
  CreateSignedUrlsRequest,
  CreateSignedUrlsResponse,
  DeleteRequest,
  FeaturesResponse,
  FindDateRangeLabelsRequest,
  FindDateRangeLabelsResponse,
  FindFeatureNamesRequest,
  FindFeatureNamesResponse,
  FindSelectedFeaturesRequest,
  FindSelectedFeaturesResponse,
  LabelResponse,
  LabelsParams,
  LabelsResponse,
  RequestParams,
} from '@/types';

export async function getLabels(params: LabelsParams & RequestParams): Promise<RequestData<LabelsResponse>> {
  return request('labels', {
    method: 'GET',
    params,
  });
}

export async function addLabel(payload: AddLabelRequest): Promise<LabelResponse> {
  return request('labels', {
    data: payload,
    method: 'POST',
  });
}

export async function editLabel({ id, ...payload }: LabelResponse): Promise<LabelResponse> {
  return request(`labels/${id}`, {
    data: payload,
    method: 'PATCH',
  });
}

export async function deleteLabel({ id }: DeleteRequest): Promise<LabelResponse> {
  return request(`labels/${id}`, {
    method: 'DELETE',
  });
}

export async function getFeatures(): Promise<FeaturesResponse[]> {
  return request('labels/features', {
    method: 'GET',
  });
}

export async function findFeatureNames({ featureName }: FindFeatureNamesRequest): Promise<FindFeatureNamesResponse[]> {
  return request(`labels/features/${featureName}`, {
    method: 'GET',
  });
}

export async function findSelectedFeatures(payload: FindSelectedFeaturesRequest): Promise<FindSelectedFeaturesResponse[]> {
  return request('labels/findSelected', {
    data: payload,
    method: 'POST',
  });
}

export async function findDateRangeLabels(payload: FindDateRangeLabelsRequest): Promise<FindDateRangeLabelsResponse[]> {
  return request('labels/findDateRangeLabels', {
    data: payload,
    method: 'POST',
  });
}

export async function createSignedUrls(payload: CreateSignedUrlsRequest): Promise<CreateSignedUrlsResponse> {
  return request('labels/createSignedUrls', {
    data: payload,
    method: 'POST',
  });
}
